import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import MapSpecs from "../mapspec/mapspecs.js";

const useStyles = makeStyles((theme) => ({
    mapParent: {
        height: "100%",
    },
    hiddenParent: {
        opacity: "0%",
    }
}));

function Map3D({ mapType }) {
    const classes = useStyles();
    const mapRef = useRef();
    const [osm, setOSM] = useState();
    const mapSpec = MapSpecs[mapType];

    // Super unfortunate but necessary. When the OSM canvas gets
    // removed, we need to reload the page. If we don't do this, then the
    // next time the OSM canvas loads, we get flickering of the canvas.
    // We tried to fix this in various ways, but nothing else worked.
    const history = useHistory();
    useEffect(() => {
        const prevOsm = mapRef.current?.osm;
        return () => {
            const osm = mapRef.current?.osm;
            if (prevOsm && !osm) {
                history.go(0);
            }
        }
    }, [mapRef.current]);

    useEffect(() => {
        if (!osm) {
            return;
        }
        osm.highlight(building => {
            if (mapSpec.buildingVisible(building.id)) {
                return "#ed5342";
            }
            return "#c2c2c2";
        });
    }, [osm, mapType]);

    useEffect(() => {
        if (!mapRef.current) {
            return;
        }
        if (osm) {
            return;
        }
        var osmb = new OSMBuildings( // eslint-disable-line no-undef
            {
                container: mapRef.current.id,
                position: { latitude: 35.6620, longitude: 139.7038 },
                zoom: 16,
                tilt: 45,
                minZoom: 14,
                maxZoom: 18,
            });
        osmb.addMapTiles('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            { attribution: '© Data <a href="http://osm.org/copyright">OpenStreetMap</a>' }
        );

        const url = `https://storage.googleapis.com/wherecaniseefuji/tiles3D/buildings/{z}_{x}_{y}.json`;
        const layer = osmb.addGeoJSONTiles(url);
        setOSM(osmb);
        mapRef.current.osm = osmb;

        // osmb.on('pointermove', function (e) {
        //     console.log(e.x, e.y);
        //     var id = osmb.getTarget(e.x, e.y, function (f) {
        //         console.log(f);
        //         // console.log(id);
        //         // if (id) {
        //         //     osmb.highlight(id, '#f08000');
        //         // } else {
        //         //     osmb.highlight(null);
        //         // }
        //     });
        // });
        // return () => {
        //     console.log("destroy!");
        //     osmb.remove();
        // }
    }, [mapRef.current, osm]);
    const rootClasses = [classes.mapParent];
    return <div className={rootClasses.join(" ")} >
        <div id="map3D" ref={mapRef} />
    </div>
}
export default Map3D;
